import { render, staticRenderFns } from "./SupplierEvaluationRisksAndProperties.vue?vue&type=template&id=00ad07d8&"
import script from "./SupplierEvaluationRisksAndProperties.vue?vue&type=script&lang=js&"
export * from "./SupplierEvaluationRisksAndProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports